
import showHeaderFooter from '@util/headerFooterUtils'
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue'
import { TripLog } from '@/generated-clients/myTrips';
import { Location } from 'vue-router';

@Component({
  name: 'NoTripsSection'
})
export default class NoTripsSection extends Vue {
  @Prop()
  private triplog: TripLog;

  @Prop({ default: false })
  private teaserWidget: boolean;

  get vehicleString() {
    const { brand, model, licensePlate } = this.triplog.vehicle;
    return licensePlate ? `${brand} ${model} (${licensePlate})` : `${brand} ${model}`;
  }

  get tripCreationLocation(): Location {
    return { name: 'myTripsAdd', query: { vehicle: this.triplog.vehicle.id.toString() } };
  }

  addHeaderFooter() {
    showHeaderFooter();
  }
}
